import * as React from "react";
import { SVGProps, memo } from "react";

const SvgLineLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg width={48} height={48} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#LineLogo_svg__a)">
      <path
        d="M37.179 0H10.821C4.845 0 0 4.845 0 10.821v26.358C0 43.155 4.845 48 10.821 48h26.358C43.155 48 48 43.155 48 37.179V10.821C48 4.845 43.155 0 37.179 0Z"
        fill="#06C755"
      />

      <path
        d="M39.999 21.738c0-7.16-7.18-12.986-16.004-12.986-8.824 0-16.003 5.826-16.003 12.986 0 6.42 5.7 11.797 13.383 12.813.522.112 1.231.343 1.41.789.162.405.106 1.04.052 1.447 0 0-.187 1.13-.228 1.37-.07.405-.322 1.583 1.386.864 1.709-.718 9.216-5.427 12.573-9.293 2.32-2.542 3.43-5.128 3.43-7.99Z"
        fill="#fff"
      />

      <path
        d="M34.674 25.873h-4.5a.3.3 0 0 1-.3-.3v-6.99a.3.3 0 0 1 .3-.3h4.5a.3.3 0 0 1 .3.3v1.136a.3.3 0 0 1-.3.3h-3.055v1.178h3.055a.3.3 0 0 1 .3.3v1.153a.3.3 0 0 1-.3.3h-3.055v1.179h3.055a.3.3 0 0 1 .3.3v1.134a.3.3 0 0 1-.3.31ZM18.043 25.873a.3.3 0 0 0 .3-.3V24.44a.3.3 0 0 0-.3-.3h-3.055v-5.55a.3.3 0 0 0-.3-.3h-1.134a.3.3 0 0 0-.3.3v6.98a.3.3 0 0 0 .3.3h4.5l-.01.005ZM20.75 18.277h-1.134a.306.306 0 0 0-.306.306v6.985c0 .168.137.305.306.305h1.134a.306.306 0 0 0 .306-.306v-6.983a.306.306 0 0 0-.306-.306ZM28.476 18.277h-1.134a.3.3 0 0 0-.3.3v4.15l-3.195-4.316a.18.18 0 0 0-.026-.032l-.018-.018-.016-.013h-.009l-.016-.012h-.01l-.016-.009H22.465a.3.3 0 0 0-.3.3v6.984a.3.3 0 0 0 .3.3h1.136a.3.3 0 0 0 .3-.3v-4.19l3.2 4.32c.02.031.047.058.078.079l.018.011h.07c.027.007.054.01.081.011h1.128a.3.3 0 0 0 .3-.3v-6.959a.298.298 0 0 0-.184-.282.3.3 0 0 0-.116-.023Z"
        fill="#06C755"
      />
    </g>

    <defs>
      <clipPath id="LineLogo_svg__a">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgLineLogo);

export default Memo;
